import { createFileRoute } from '@tanstack/react-router';
import DeliveryWindowsPage from '../../../../features/delivery-windows/DeliveryWindowsPage.tsx';
import UserLayout from '@components/layout/UserLayout.tsx';
import { z } from 'zod';
import { useDeliveryWindowsStore } from '@stores/deliveryWindowsStore.ts';
import { isNotNullOrUndefined } from '@utils/utils.tsx';

const searchSchema = z.object({
  mode: z.enum(['all', 'with', 'without']).optional().default('all'),
  page: z.number().default(1),
  supplierName: z.string().optional(),
});

export const Route = createFileRoute('/c/$orgId/$portalId/delivery-windows')({
  validateSearch: v => searchSchema.parse(v),
  component: RouteComponent,
  beforeLoad: ctx => {
    const { portalId, orgId } = ctx.params;
    const { page, supplierName, mode } = ctx.search;

    const configured = mode === 'all' ? null : mode === 'with' ? true : false;
    useDeliveryWindowsStore.getState().fetchDeliveryWindows(orgId, portalId, page, 10, undefined, configured, supplierName);
  },
});

function RouteComponent() {
  const nav = Route.useNavigate();
  const deliveryWindows = useDeliveryWindowsStore(s => s.deliveryWindows);

  const handlePageChange = (page: number) => {
    nav({
      search: p => ({ ...p, page }),
    });
  };

  const handleSearch = (query: string) => {
    nav({
      search: p => ({ ...p, supplierName: query, page: 1 }),
    });
  };

  const handleMode = (mode: 'all' | 'with' | 'without') => {
    nav({
      search: p => ({ ...p, mode, page: 1 }),
    });
  };

  return (
    <UserLayout>
      {isNotNullOrUndefined(deliveryWindows) && (
        <>
          <DeliveryWindowsPage handlePageChange={handlePageChange} handleSearch={handleSearch} handleMode={handleMode} />
        </>
      )}
    </UserLayout>
  );
}
